// OccurrenceListModal.jsx
import React from 'react';
import { Modal, Button, Table, Spinner, Alert } from 'react-bootstrap';

function fmtDate(iso) {
    if (!iso) return '-';
    const d = new Date(iso);
    if (isNaN(d)) return '-';
    return d.toLocaleString(); // or toLocaleDateString() if you want only date
}

export default function OccurrenceListModal({
    show, onHide, list, loading, error, onOpen,
}) {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title>Occurrences</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading && (
                    <div className="d-flex align-items-center gap-2">
                        <Spinner animation="border" size="sm" />
                        <span>Loading...</span>
                    </div>
                )}
                {error && <Alert variant="danger" className="mt-2">{error}</Alert>}

                {!loading && !error && (!list || list.length === 0) && (
                    <div>No occurrences found for this shift.</div>
                )}

                {!loading && !error && list && list.length > 0 && (
                    <Table bordered hover responsive className="mb-0 mt-2">
                        <thead className="main-tableheader">
                            <tr>
                                <th style={{ width: 120, backgroundColor: 'blueviolet' }}>ID</th>
                                <th style={{ backgroundColor: 'blueviolet' }}>Name</th>
                                <th style={{ width: 220, backgroundColor: 'blueviolet' }}>Date</th>
                                <th style={{ width: 120, backgroundColor: 'blueviolet' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.map((it) => (
                                <tr key={it.incidentId}>
                                    <td>#{it.incidentId}</td>
                                    <td>{it.name || '-'}</td>
                                    <td>{fmtDate(it.dateOfIncident)}</td>
                                    <td>
                                        <Button size="sm" onClick={() => onOpen(it)}>
                                            Open
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}
